<template>
  <div>
    <nav-bar @switchSelected="switchSelected"></nav-bar>
    <div class="view">
      <router-view></router-view>
    </div>
    <the-footer></the-footer>
    <link rel="preconnect" href="https://fonts.googleapis.com"> 
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin> 
    <link href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap" rel="stylesheet">
  </div>
</template>

<script>
import NavBar from './components/layout/NavBar.vue';
import TheFooter from './components/layout/TheFooter.vue';
import { mapActions } from 'vuex'; 

// import WelcomePage from './components/layout/WelcomePage.vue';
// import ProductList from './components/layout/ProductList.vue';
export default {
  data () {
    return {
      selectedTab: 'welcome-page',
    };
  },
  components: {
    NavBar,
    TheFooter,
  },
  methods: {
    switchSelected(componentId) {
      this.selectedTab = componentId;
    },
    ...mapActions(['checkToken']),
  },
  mounted() {
    if (!localStorage.cart) {
      localStorage.cart = '[]';
    }
    // this.checkToken();
  }
}
</script>

<style>
.view {
  min-height: 80vh;
}
</style>
